export const INSIGHTS_HOME = "https://insights.globalcitizenconsult.com";

export const INSIGHTS_ARTICLES = [
  {
    category: "Implementation",
    title: "Why Most Offshore Plans Fail at Implementation",
    url: INSIGHTS_HOME,
  },
  {
    category: "Advisory model",
    title: "What a family gets from a 145 page deck that nobody reads",
    url: INSIGHTS_HOME,
  },
  {
    category: "Structure",
    title: "The single family office that does not need an office",
    url: INSIGHTS_HOME,
  },
];
